import { render, staticRenderFns } from "./81.vue?vue&type=template&id=f781a39a&scoped=true&"
var script = {}
import style0 from "./81.vue?vue&type=style&index=0&id=f781a39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f781a39a",
  null
  
)

export default component.exports